<template>
    <div class="card border-0 bg-success text-white">
      <div class="card-body">
        <div class="d-flex flex-wrap align-items-center">
          <i class="fe fe-download font-size-50 mr-3" />
          <div>
            <div class="font-size-30 font-weight-bold">{{ setComma(countTotal) }} ครั้ง</div>
            <div class="font-size-18 font-weight-bold">จำนวนการเติมเงิน QR (ครั้ง)</div>
          </div>
        </div>
      </div>
    </div>
  </template>
<script>
export default {
  name: 'KitChart11',

  props: [
    'countTotal',
  ],
  methods: {
    setComma(value) {
      if (value > 0 && value !== null) {
        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      } else {
        return 0
      }
    },
  },
}
</script>
  <style lang="scss" module>
  </style>
